import { render, staticRenderFns } from "./PublishingContractsEdit.vue?vue&type=template&id=b44749ba"
import script from "./PublishingContractsEdit.vue?vue&type=script&lang=js"
export * from "./PublishingContractsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports